import clsx from 'clsx'
import type { ComponentPropsWithoutRef } from 'react'

type FieldsetProps = ComponentPropsWithoutRef<'fieldset'>
type FieldGroupProps = ComponentPropsWithoutRef<'div'>
type FieldProps = ComponentPropsWithoutRef<'div'>

export function Fieldset({ className, ...props }: FieldsetProps) {
  return <fieldset {...props} className={clsx(className, '*:data-[slot=text]:mt-1 [&>*+[data-slot=control]]:mt-6')} />
}

export function FieldGroup({ className, ...props }: FieldGroupProps) {
  return <div data-slot="control" {...props} className={clsx(className, 'space-y-8')} />
}

export function Field({ className, ...props }: FieldProps) {
  return (
    <div
      {...props}
      className={clsx(
        className,
        '[&>[data-slot=label]+[data-slot=control]]:mt-3',
        '[&>[data-slot=label]+[data-slot=description]]:mt-1',
        '[&>[data-slot=description]+[data-slot=control]]:mt-3',
        '[&>[data-slot=control]+[data-slot=description]]:mt-3',
        '[&>[data-slot=control]+[data-slot=error]]:mt-3',
        '*:data-[slot=label]:font-medium'
      )}
    />
  )
}
